document.querySelectorAll( '.b-big-content-card' ).forEach( ( block ) => {

	const buttons = block.querySelectorAll( '.wp-block-button' );
	const content = block.querySelector( '.b-big-content-card__items' );

	buttons.forEach( button => {

		button.addEventListener( 'click', () => {

			if ( content ) {

				content.classList.toggle( 'b-big-content-card__items--active' );
				content.style.maxHeight = content.style.maxHeight ? null : `${content.scrollHeight}px`;

				buttons.forEach( currentButton => {

					currentButton.classList.toggle( 'wp-block-button--active' );

					if ( currentButton.classList.contains( 'wp-block-button--active' ) && content.classList.contains( 'b-big-content-card__items--active' ) ) {

						currentButton.classList.add( 'wp-block-button--open-content' );

					} else {

						currentButton.classList.remove( 'wp-block-button--open-content' );

					}

				} );

			}

		} )

	} );


} );

/**
 * Debounce
 *
 * @param {function} callback
 * @param {integer} delay
 * @return {(function(...[*]): void)|*}
 */
const debounce = ( callback, delay ) => {

	let timeout;
	return function executedFunction( ...args ) {

		/** */
		const later = () => {

			clearTimeout( timeout );
			callback( ...args );

		};
		clearTimeout( timeout );
		timeout = setTimeout( later, delay );

	};

}

/**
 * Recalculate Open Accordions
 */
const recalculateOpenAccordions = () => {

	document.querySelectorAll( '.b-big-content-card__items.active' ).forEach( contentActive => {

		contentActive.style.maxHeight = `${contentActive.scrollHeight}px`;

	} );

};
const debounceRecalculateAccordion = debounce( recalculateOpenAccordions, 50 );
window.addEventListener( 'resize', debounceRecalculateAccordion );